import React, { useState, useEffect } from "react";
import { ProSidebar, SidebarHeader, SidebarContent, SidebarFooter, Menu, MenuItem } from 'react-pro-sidebar';
import "react-pro-sidebar/dist/css/styles.css";
import classNames from 'classnames';
import arrow_left from '../assets/images/arrow_left.svg';
import arrow_right from '../assets/images/arrow_right.svg';
import logosidebar from '../assets/images/logo_sidebar.svg';
import logosidecollaps from '../assets/images/logo_sidecollaps.svg';
import Dashboard from "./dashboard.js";
import cam_select from "../assets/images/cam_select.svg";
import cam_unselect from "../assets/images/cam_unselect.svg";
import db_select from "../assets/images/db_select.svg";
import db_unselect from "../assets/images/db_unselect.svg";
import '../assets/styles/admin.css';
import membericon from '../assets/images/memneradd.svg';
import memberselect from '../assets/images/member_select.svg'
import { useNavigate } from 'react-router-dom';
import fd_select from '../assets/images/fd_select.svg';
import fd_unselect from '../assets/images/fd_unselect.svg';
import Tools from "./Tools.js";
import Client from "./Client.js";
import Franchise from '../pages/Franchise'
import Franchise_select from '../assets/Francias/francias_slect.svg';
import Franchise_unselect from '../assets/Francias/francias_unslect.svg';
import  user from '../assets/Francias/user.svg';
import Request from "./Requestpage.js";
import NotificationModal from "./Notification.js";
import notify_icon from '../assets/Francias/notiico.svg'


const Admin = () => {

  const [isNotifyModalOpen, setIsNotifyModalOpen] = useState(false);
  const openNotifyModal = () => {  setIsNotifyModalOpen(true); };

  const handleNotifyClosePopup = () => { setIsNotifyModalOpen(false); }

  const currentpage =localStorage.getItem('currentpage');
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [menuCollapse, setMenuCollapse] = useState(false);
  
  const [activePage, setActivePage] = useState( currentpage ?  currentpage:'Dashboard');
  const [activePageForSel, setActivePageForSel] = useState( currentpage?  currentpage:'Dashboard');
  const [activeSubPage, setActiveSubPage] = useState('');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  const menuIconClick = () => {
    setMenuCollapse(!menuCollapse);
  };

  const handleItemClick = (page) => {
    if (page === "Client" || page === "Dashboard" || page === "Franchise" || page === "Request" || page === "Tools" ) {
      setActivePage(page);
      localStorage.setItem('currentpage', page);
    }
    setActivePageForSel(page);
  };
  const handleSubItemClick = (page) => {
    setActiveSubPage(page);
  }
  const menuItems = [
    { name: 'Dashboard', icons: { select: db_select, unselect: db_unselect } },
    { name: 'Client', icons: { select: cam_select, unselect: cam_unselect } },
    { name: 'Franchise', icons: { select: Franchise_select, unselect: Franchise_unselect } },
    { name: 'Request',icons: { select: fd_select, unselect: fd_unselect }},
    { name: 'Tools',icons: { select: memberselect, unselect:membericon}},
  ];

  const renderActivePage = () => {
      switch (activePage) {
          case 'Dashboard':
          return <Dashboard />;
          case 'Client':
          return <Client pageName={activePage}/>;
          case 'Franchise':
            return <Franchise/>
          case 'Request':
          return <Request/>;
          case 'Tools':
            return<Tools/>;
          default:
          return <Dashboard />;
      } 
  };
  const handleLogout = () => {
    const userConfirmed = window.confirm("Are you sure you want to log out?");
    if (userConfirmed) {
      localStorage.removeItem("authToken");
      navigate("/");
    } else {
      console.log("User canceled logout");
    }
  };
  return (
    <div id="header">
      {windowWidth <= 600 ? (
        <div className="bottom-bar">
          {menuItems.map(({ name, icons, label }) => (
            <div
              key={name}
              className={classNames('bottom-bar-item', {
                'active-item': activePage === name,
                'active-item-ml': menuCollapse,
              })}
              onClick={() => handleItemClick(name)}
            >
              <img src={activePage === name ? icons.select : icons.unselect} alt={`${name}_select`} />
              <span>{label}</span>
            </div>
          ))}
        </div>
      ) : (
        <ProSidebar collapsed={menuCollapse}>
          <SidebarHeader>
            <div className="logotext">
              {menuCollapse ? (
                <img src={logosidecollaps} alt="Collapsed Logo" />
              ) : (
                <img src={logosidebar} alt="Sidebar Logo" />
              )}
            </div>
            
          </SidebarHeader>

          <SidebarContent>
            <Menu iconShape="square">
              {menuItems.map(({ name, icons, subMenuItems }) => (
                <div key={name}>
                  <MenuItem
                    className={classNames('menu-item-transition', {
                      'active-item': activePageForSel === name,
                      'active-item-ml': menuCollapse,
                    })}
                    onClick={() => handleItemClick(name)}
                  >
                    <img
                      src={activePageForSel === name ? icons.select : icons.unselect}
                      alt={`${name}_select`}
                    />
                    {!menuCollapse && (
                      <p className={`text-sb-mm ${activePageForSel === name ? 'sb-select-mm' : ''}`}>
                        {name}
                      </p>
                    )}

                    
                  </MenuItem>
                  {activePageForSel === name && subMenuItems && subMenuItems.length > 0 && (
                    <div className="subitem-cm">
                      {subMenuItems.map((subItem) => (
                        <div
                          key={subItem.name}
                          className={classNames('dropdown-item', {
                            'active-subitem': activeSubPage === subItem.name,
                          })}
                          onClick={() => handleSubItemClick(subItem.name)}
                        >
                          {subItem.name} {subItem.name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </Menu>           
          </SidebarContent>
          <SidebarFooter>
            <Menu iconShape="square">
              <MenuItem
                className={classNames('menu-item-transition', {
                  'active-item': activePage === 'Profile',
                  'active-item-ml': menuCollapse,
                })}
              >
                <img
                  src={user}
                  onClick={handleLogout}
                  alt="profile_select"
                />
                {!menuCollapse && (
                  <div className="d-flex" onClick={handleLogout}>
                    <p className={`text-sb-mm ${activePage === 'Profile' ? 'sb-select-mm' : ''}`} >Logout</p>
                  </div>
                )}
              </MenuItem>
             
            </Menu>
          </SidebarFooter>
        </ProSidebar>
      )}
      <div className={menuCollapse ? 'members-body collabs-body-mm' : 'members-body'}>
        <div className="body-header-mm">
          {windowWidth <= 600 ? (
            <div className="d-flex align-items-center FullWidth">
              <img src={logosidecollaps} alt="Sidebar Logo" />
              <h5 className="header-title-mm" >{activePage}</h5>
              <div
                className={'bottom-bar-item mobile-user'}
                onClick={handleLogout}
              >  
              </div>
              <div>
              <img
                  src={user}
                  alt="profile_select"
                  onClick={handleLogout}
                />
                </div>
                
            </div>
            
          ) : (
            <div
              className="closemenu d-flex"
              onClick={menuIconClick}
              role="button"
              tabIndex="0"
              aria-label="Toggle Sidebar"
            >
              {menuCollapse ? (
                <img src={arrow_right} className="com-width-mm" alt="arrow_right" />
              ) : (
                <img src={arrow_left} className="com-width-mm" alt="arrow_left" />
              )}
              <h5 className="header-title-mm">{activeSubPage === "" ? activePage : activeSubPage}</h5>
            </div>
          )}
           <div className="">
           {(activePage === "Dashboard" && !activeSubPage) && (
            < div>
            <img
                src={notify_icon}
                alt='notify_icon'
                className='notify-icon-main'
                onClick={openNotifyModal}
              />
              {isNotifyModalOpen && (
                <NotificationModal closePopup={handleNotifyClosePopup}/>
              )}
            </div>
          )}
           </div>
        </div>
        
        <div className="body-container-mm">
          {renderActivePage()}
        </div>
      </div>
    </div>
  );
};

export default Admin;
